// extracted by mini-css-extract-plugin
module.exports = {"heading":"PresentationPopup_heading__3IqNB"};